import vtkCleanPolyData from './CleanPolyData';
import vtkClipPolyData from './ClipPolyData';
import vtkCutter from './Cutter';
import vtkPolyDataNormals from './PolyDataNormals';
import vtkThresholdPoints from './ThresholdPoints';

export default {
  vtkCleanPolyData,
  vtkClipPolyData,
  vtkCutter,
  vtkPolyDataNormals,
  vtkThresholdPoints,
};
